import React from 'react'

import { DDSIconDefinition, Icon, IconButton, Link } from '@driftt/dds'

import { segmentTrack, TrackType } from 'utils/tracking'

interface SocialLinkIconButtonsProps {
  validation: boolean
  trackType: TrackType
  href: string
  tooltip: string
  icon: DDSIconDefinition
  trackAttrs?: any
}

const SocialLinkIconButtons = ({
  validation,
  trackType,
  href,
  tooltip,
  icon,
  trackAttrs,
}: SocialLinkIconButtonsProps) => {
  if (!validation) return null

  return (
    <Link external onClick={() => segmentTrack(trackType, trackAttrs)} truncate href={href} target="_blank">
      <IconButton title={tooltip} size="default" icon={<Icon color="gray11" icon={icon} />} />
    </Link>
  )
}

export default SocialLinkIconButtons
